import { Button } from '@mui/material'
import Send from '@mui/icons-material/Send'

export default function FeedbackButton({ onShowFeedback, disabled = false }) {
  if (disabled) return null

  return (
    <Button
      size="small"
      variant="contained"
      onClick={onShowFeedback}
      disabled={disabled}
      endIcon={<Send />}
      disableElevation
    >
      Give Feedback
    </Button>
  )
}
